import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { IMG, SOCIAL } from "../config";
import { ChapterHead } from "./ChapterHead";

export const InstagramFeed = ({ t }) => {
    const photos = [
        IMG.exterior,
        IMG.interior,
        IMG.lounge,
        IMG.room,
        IMG.kitchen,
        IMG.dorms,
        IMG.dining,
        IMG.bar,
        IMG.tvRoom,
        IMG.guestsBar,
    ];
    return (
        <section data-testid="instagram-section" className="relative overflow-hidden py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-5 sm:px-6">
                <ChapterHead chapter={t.ig.chapter} label={t.ig.label} title={t.ig.title} />
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="-mt-4 mb-10 max-w-lg text-sm leading-relaxed text-[#1b0b06]/70 sm:text-base"
                >
                    {t.ig.text}
                </motion.p>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
                    {photos.map((src, i) => (
                        <motion.a
                            key={src + i}
                            href={SOCIAL.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`instagram-photo-${i}`}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.5, delay: i * 0.07 }}
                            className="group relative aspect-square overflow-hidden rounded-2xl"
                            aria-label={`Instagram Matianellu foto ${i + 1}`}
                        >
                            <img
                                src={src}
                                alt={`Matianellu Hostel — Instagram ${i + 1}`}
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-[#f23218]/0 transition-colors duration-300 group-hover:bg-[#f23218]/60">
                                <Instagram size={28} className="text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                            </div>
                        </motion.a>
                    ))}
                </div>
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="mt-8"
                >
                    <a
                        href={SOCIAL.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="instagram-follow-btn"
                        className="inline-flex items-center gap-2 rounded-full border-2 border-[#1b0b06] px-6 py-3 text-sm font-extrabold uppercase tracking-wider text-[#1b0b06] transition-colors hover:bg-[#1b0b06] hover:text-[#fbf3e8]"
                    >
                        <Instagram size={17} />
                        {t.ig.cta}
                    </a>
                </motion.div>
            </div>
        </section>
    );
};
